import React, {useState} from 'react';
import {useNavigate} from "react-router";
import {
  Button,
  FlexItem, FormField, FormFieldHelperText, FormFieldLabel, Input, StackLayout,

} from '@salt-ds/core';
import '../CommonCard.css';
import PageNavigation from '../../components/common/page-navigation/PageNavigation';
import Constants from '../../components/common/Constants';
import {HiddenIcon, VisibleIcon} from '@salt-ds/icons';
import {registerDevice, sendAnotherRegistrationAccessCode} from "../../api/LoginApi";
import { getAuthToken } from '../../common/authTokenUtil';

function RegisterComputerVerifyForm(props) {

  const navigate = useNavigate();
  const [formData, setFormData] = useState({accessCode: "", password: ""});

  // const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({
    accessCode: {required: false, invalid: false},
    password: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const {name, value} = event.target;

    setFormData((prevFormData) => ({...prevFormData, [name]: value}));

    //Clear error when user begins to type
    if (name === 'accessCode') {
      setErrors((prevErrors) => ({
        ...prevErrors,
        accessCode: {required: false, invalid: false},
      }));
    } else if (name === 'password') {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: false,
      }));
    }
  };

  const handleAnotherAccessCodeClick = (event) => {
    setIsSubmitting(true);
    event.preventDefault();
    props.setIsAnotherAccessCodeButtonClicked(true);
    props.showSpinner();
    sendAnotherRegistrationAccessCode(props.orgId, props.userId, props.secretPhrase, props.deviceSignature)
      .then(() => {
        props.hideSpinnerAndShowAnotherAccessCodeMessage();
        setIsSubmitting(false);
      })
      .catch(() => {
        setIsSubmitting(false);
      });
  }

  const verifyRegistration = async (accessCode, password) => {
    try {
      
      props.showSpinner();
      const registrationResponse = await registerDevice(
          props.deviceSignature,
          accessCode,
          password,
          props.orgId,
          props.userId,
          getAuthToken()
      );

      // Assuming a successful registration returns a specific property, e.g., success or status
      const isRegisteredSuccessfully = (registrationResponse && registrationResponse.data === true);
      if (registrationResponse.error && registrationResponse.error.detail) {
        props.showErrorOnPage(registrationResponse.error.detail);
      }else if(!isRegisteredSuccessfully) {
        props.hideSpinnerAndShowError();
      }
      return isRegisteredSuccessfully;
    } catch (error) {
      // If there is an error, consider the access code invalid

        props.hideSpinnerAndShowError();
      return false;
    }
  }

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    event.preventDefault();

    //Validation for empty fields
    const newErrors = {
      accessCode: {
        required: formData.accessCode === '',
        invalid: formData.accessCode !== '',//add access code verification condition here
      },
      password: formData.password.trim() === ''
    };
    setErrors(newErrors);

    const hasValidationErrors = newErrors.accessCode.required || newErrors.password;
    if (hasValidationErrors) {
      setIsSubmitting(false);
      return;
    }
    props.showSpinner();

    const verifyRegistrationResult = await verifyRegistration(formData.accessCode, formData.password);
    if(verifyRegistrationResult) {
      navigate(Constants.registerComputerOptions,{state: { from: Constants.registerComputer }});
    }else {
      clearFieldsAfterError();
      props.setHasError(true);
    }
    // After your async logic, set isSubmitting to false if not navigating away
    setIsSubmitting(false);
  };

  const clearFieldsAfterError = () => {
    setFormData(prevFormData=> ({...prevFormData, accessCode: "", password: ""}));
  }

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <form autoComplete="off" onSubmit={handleSubmit} data-testid="register-computer-verify-form-submit">
      <fieldset disabled={isSubmitting} style={{border:0, padding:0, margin:0}}>
      <StackLayout className="form-layout" gap={2}>
        <FlexItem>
          <FormField
            validationStatus={(errors.accessCode.required) ? "error" : undefined}>
            <FormFieldLabel>{Constants.registrationCodeLabel}</FormFieldLabel>
            <Input inputProps={{name:"accessCode", "aria-required": "true", "aria-describedby": (errors.accessCode.required || errors.accessCode.invalid) ? "accessCode-error" : undefined}} onChange={handleChange} value={formData.accessCode} />

            {((errors.accessCode.required || errors.accessCode.invalid) === false) &&
              <FormFieldHelperText id="accessCode-error" role="alert">{Constants.registrationCodeHelperText}</FormFieldHelperText>}
            <FormFieldHelperText id="accessCode-error" role="alert">{errors.accessCode.required ? Constants.requiredFieldError : Constants.registrationCodeHelperText }</FormFieldHelperText>
          </FormField>
        </FlexItem>
        <FlexItem>
          <FormField  validationStatus={errors.password ? "error" : undefined}>
            <FormFieldLabel>Password</FormFieldLabel>
            <div>
              <Input inputProps={{name:"password",type: (showPassword ? "text" : "password"), maxLength: "25", "aria-required": "true",
                "aria-describedby": errors.password ? "password-error" : undefined}}
                value={formData.password} onChange={handleChange}/>
              {errors.password ? "" :
                (showPassword ?
                <VisibleIcon tabIndex={0} className={'password-icon'}
                      onClick={togglePasswordVisibility}
                      onKeyPress={togglePasswordVisibility} />
                  : <HiddenIcon tabIndex={0} className={'password-icon'}
                    onClick={togglePasswordVisibility}
                    onKeyPress={togglePasswordVisibility} />
                )}
            </div>
            {errors.password && (
              <FormFieldHelperText id="password-error" role="alert">
                {Constants.requiredFieldError}
              </FormFieldHelperText>
            )}
            {!errors.password && (
              <FormFieldHelperText>
                {Constants.passwordHelper}
              </FormFieldHelperText>
            )}
          </FormField>
        </FlexItem>
        <FlexItem>
          <Button sentiment="accented" appearance= "bordered" type="button" onClick={handleAnotherAccessCodeClick}>
            {Constants.accessCodeButton}
          </Button>
        </FlexItem>
      </StackLayout>
        <PageNavigation style={{marginTop: "5%"}}/>
      </fieldset>
    </form>
      );
      }

      export default RegisterComputerVerifyForm;